import _pickBy from 'lodash/pickBy';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import { PARTICIPANT_ID_ALL } from '../../modules/unread-chatroom-count/reducer.unread-chatroom-count';
export var filterChatrooms = function (chatrooms, filter) {
    return _pickBy(chatrooms, function (room) { return shouldFilterChatroom(room, filter); });
};
export function shouldFilterChatroom(chatroom, filter) {
    if (!filter || _isEmpty(filter)) {
        return !chatroom.isArchived;
    }
    else {
        var filters = [shouldFilterArchived, shouldFilterByParticipantId, shouldFilterByParticipantType, shouldFilterByLabelId];
        return filters.every(function (f) { return f(chatroom, filter); });
    }
}
function shouldFilterArchived(chatroom, filter) {
    if (filter.isArchived) {
        return !!chatroom.isArchived;
    }
    else {
        return !chatroom.isArchived;
    }
}
function shouldFilterByParticipantId(chatroom, filter) {
    var _a;
    if ((_a = filter.participantIds) === null || _a === void 0 ? void 0 : _a.length) {
        return filter.participantIds.some(function (pid) { return pid === chatroom.participantId || pid === PARTICIPANT_ID_ALL; });
    }
    else {
        return true;
    }
}
function shouldFilterByParticipantType(chatroom, filter) {
    if (filter.participantType === 'business') {
        var isCurrentUserContributor = chatroom.participantId === _get(chatroom, 'businessContext.id');
        return isCurrentUserContributor && chatroom.pluginName === 'Engage';
    }
    else if (filter.participantType === 'siteMember') {
        var isCurrentUserMember = chatroom.participantId !== _get(chatroom, 'businessContext.id');
        return chatroom.pluginName === 'Social' || (chatroom.pluginName === 'Engage' && isCurrentUserMember);
    }
    else {
        return true;
    }
}
function shouldFilterByLabelId(chatroom, filter) {
    if (filter.labelIds && filter.labelIds.length && chatroom.labelIds) {
        return filter.labelIds.some(function (labelId) { return chatroom.labelIds.includes(labelId); });
    }
    else {
        return true;
    }
}
